/* istanbul ignore file */

import { createUseStyles } from '@glu/theming';

export default createUseStyles(() => ({
  spinnerWrapper: {
    display: 'flex',
    justifyContent: 'center'
  },
  wrapper: {
    width: '100%',
    flexDirection: 'column'
  }
}));
